
import { Expand } from "lucide-react"
import { useEffect,useState} from "react"
import { Table } from "reactstrap"
import ApiService from "../../services/apiService"

const ChackOnOf = ({ chackData, onFilterChange ,  filterDeviceType,  excludeDeviceTypes  }: { chackData: any[], onFilterChange: (filter: 'all' | 'online' | 'offline') => void ,  filterDeviceType?: string, excludeDeviceTypes?: string[] }) => {


   const [selectedChak,setSelectedChak] = useState<string>('all')
   

  let online = 0;
  let offline = 0;
  const filteredData = chackData
  .filter((d: any) => filterDeviceType ? d.deviceType === filterDeviceType : true)
  .filter((d: any) => excludeDeviceTypes?.length 
    ? !excludeDeviceTypes.includes(d.deviceType) 
    : true
  );
  filteredData .forEach((data: any) => {
    const apiTime = new Date(String(data.dateTime).replace(' ', 'T'));
    const currentTime = new Date();
    const diffMilli = currentTime.getTime() - apiTime.getTime();
    const diffHours = diffMilli / (1000 * 60 * 60);

    if (diffHours > 24) offline++;
    else online++;
  });

  return (
    <>
      
      <Table>
        <thead className="bg-light-primary">
          <tr>
            <th style={{cursor:'pointer',fontWeight:'500',fontSize:'14px'}} onClick={() => {onFilterChange('all') }}><strong>Total Chaks</strong></th>
            <th style={{cursor:'pointer',fontWeight:'500',fontSize:'14px'}} onClick={() => onFilterChange('online')}><strong>Online</strong></th>
            <th style={{cursor:'pointer',fontWeight:'500',fontSize:'14px'}} onClick={() => onFilterChange('offline')}><strong>Offline</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{cursor:'pointer',fontSize:'16px',
              ...(selectedChak == 'all' ?{backgroundColor:'#E2DFD2',
                color:'black',
                borderRadius:'50px',
                textAlign:'center'
             
              }:'' ) }} onClick={() => {onFilterChange('all'); setSelectedChak('all')}}>{filteredData.length}</td>
            <td  onClick={() => {onFilterChange('online'); setSelectedChak('online')}} style={{ color: "green",cursor:'pointer',
                   fontSize:'16px',
               ...(selectedChak == 'online' ?{backgroundColor:'green',
                color:'white',
                borderRadius:'50px',
                textAlign:'center'
             
              }:'' )
             }}>{online}</td>
            <td onClick={() => {onFilterChange('offline'); setSelectedChak('offline')}} style={{ color: "red", cursor:'pointer',fontSize:'16px',...(selectedChak == 'offline' ?{backgroundColor:'red',
                color:'white',
                borderRadius:'50px',
                textAlign:'center'
             
              }:'' )}}>{offline}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default ChackOnOf;
